import bootstrapNotify from './bootstrapNotify.js';

const httpRequest = {
	/**
	 * Beschrijving
	 *
	 * @param {string} method
	 * @param {object} callback
	 * @param {object|null} body
	 * @param {bool} async
	 *
	 * @returns {string}
	 */
	send: function(method, url, callback, body = null, async = true) {
		var xhr = new XMLHttpRequest();
		xhr.open(method.toUpperCase(), url, async);
		xhr.onload = function() {
			if (this.status >= 200 && this.status < 400) {
				callback(this.response);
			} else {
				bootstrapNotify('danger', '', 'Er is iets misgegaan. Probeer het nogmaals.');
			}
		};
		xhr.send(body);
	},

	/**
	 * Beschrijving
	 *
	 * @param {object} url
	 * @param {object} callback
	 *
	 * @returns {string}
	 */
	get: function(url, callback) {
		httpRequest.send('GET', url, callback);
	},

	/**
	 * Beschrijving
	 *
	 * @param {object} url
	 * @param {object} callback
	 * @param {object|null} body
	 *
	 * @returns {string}
	 */
	post: function(url, callback, body = null) {
		httpRequest.send('POST', url, callback, body);
	},

	/**
	 * Beschrijving
	 *
	 * @param {object} url
	 * @param {object} callback
	 * @param {object|null} body
	 *
	 * @returns {string}
	 */
	put: function(url, callback, body = null) {
		httpRequest.send('PUT', url, callback, body);
	},

	/**
	 * Encode data voor submit
	 *
	 * @param {object} data
	 *
	 * @returns {string}
	 */
	encodeFormData: function(data) {
		var formData = new FormData();
		for (let [index, value] of Object.entries(data)) {
			if (typeof value == 'object') {
				value = JSON.stringify(value);
			}
			formData.append(index, value);
		}
		return formData;
	},

};

export default httpRequest;
